<template src='./duplicateMovementsAnalysis.pug' lang='pug'></template>

<script>
import ConfirmModal from '../../../modals/confirmModal/ConfirmModal'
import ButtonPrimary from '../../../buttons/buttonPrimary/ButtonPrimary'
import PageTitle from '../../../layout/pageTitle/PageTitle'
import { VueTabs, VTab } from 'vue-nav-tabs'
import DuplicateMovements from '../../../reports/duplicateMovementsAnalysis/DuplicateMovements'
import AnnulledMovements from '../../../reports/duplicateMovementsAnalysis/AnnulledMovements'
import TreeGrid from '../../../treeGrid/TreeGrid'
import { EXPORT_TREEGRID } from '../../../../../build/jsonToExcel/exportRoutes.js'
import { startTreeGridLoading, stopTreeGridLoading } from '../../../../utils/grid-load-transition.js'

export default {
  name: 'DuplicateMovementsAnalysis',

  components: {
    ConfirmModal,
    ButtonPrimary,
    PageTitle,
    VueTabs,
    VTab,
    DuplicateMovements,
    AnnulledMovements,
    TreeGrid
  },

  data () {
    return {
      currentTab: 'tabDuplicated',
      disableSearchButton: false,
      disableConfirmButton: false,
      showTreegrid: false,
      searchData: {
        gridId: '',
        actionName: '',
        filter: {}
      },
      treeGridCfg: {},
      exportUrl: EXPORT_TREEGRID,
      result: {},
      movements: {}
    }
  },

  computed: {
    labelConfirmacaoAnulacao () {
      return this.searchData.gridId === 'LancamentoDuplicado' ? this.$t('analiseDuplicidade.mensagem.confirmarAnularLancamento') : this.$t('analiseDuplicidade.mensagem.confirmarReverterAnulacao')
    },
    labelAlertaAnulacao () {
      return this.searchData.gridId === 'LancamentoDuplicado' ? this.$t('analiseDuplicidade.labels.alertaGridAnularLancamneto') : this.$t('analiseDuplicidade.labels.alertaGridReverterAnulacao')
    }
  },

  methods: {
    handleTabChange (tabIndex) {
      this.showTreegrid = false
      this.currentTab = tabIndex === 0 ? 'tabDuplicated' : 'tabAnnulled'
    },

    searchMovements (searchData) {
      this.showTreegrid = true
      this.searchData = searchData

      startTreeGridLoading(`#${this.searchData.gridId}`)

      this.disableSearchButton = true
      this.$store.dispatch(this.searchData.actionName, { filter: this.searchData.filter })
        .then((response) => {
          window.DisposeGrids()
          const data = response.data

          data.Body = response.data.Body.map(elements => {
            return elements.map(element => {
              const checkCanEdit = element.SitConciliacao === '' || element.SitConciliacao === 'A' ? '1' : '0'
              return {...element, CheckCanEdit: checkCanEdit}
            })
          })

          this.result = data
          this.treeGridCfg = data.Cfg.Layout
          stopTreeGridLoading(`#${this.searchData.gridId}`)
          this.disableSearchButton = false
        }).catch((error) => {
          this.error = true
          this.msgError = error.body
          this.$root.$refs.notification.error('GENERAL')
          stopTreeGridLoading(`#${this.searchData.gridId}`)
          this.disableSearchButton = false
        })
    },

    annulMovementsOpenModalConfirm (movements) {
      this.movements = movements
      $('#confirmUpdateAnnulledField').modal('show')
    },

    annulMovementsCloseModalConfirm () {
      $('#confirmUpdateAnnulledField').modal('hide')
    },

    annulMovements () {
      this.disableConfirmButton = true
      this.$store.dispatch('annulledMovements', this.movements)
        .then(response => {
          this.movements = {}
          this.$root.$refs.notification.success(this.searchData.gridId === 'LancamentoDuplicado' ? 'analiseDuplicidade.mensagem.anulacaoSucesso' : 'analiseDuplicidade.mensagem.reverterAnulacaoSucesso')
          this.annulMovementsCloseModalConfirm()
          this.disableConfirmButton = false
          this.searchMovements(this.searchData)
        })
        .catch(error => {
          this.$root.$refs.notification.error(error)
          this.disableConfirmButton = false
          this.annulMovementsCloseModalConfirm()
        })
    }
  }
}
</script>



// WEBPACK FOOTER //
// DuplicateMovementsAnalysis.vue?2c7535a8